<template>

  <el-main>
    <el-row>
      <el-col>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/nav/list' }">导航列表</el-breadcrumb-item>
          <el-breadcrumb-item>导航详情</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <el-image class="navigation-logo-large" :src="navigation.icon" :alt="navigation.name"></el-image>
      </el-col>
      <el-col :span="18">
        <el-descriptions :column="1" :title="navigation.name">
          <el-descriptions-item label="收录日期">{{navigation.created_at}}</el-descriptions-item>
          <el-descriptions-item label="网站标题">{{navigation.title}}</el-descriptions-item>
          <el-descriptions-item label="网站描述">{{navigation.description}}</el-descriptions-item>
        </el-descriptions>
        <el-link class="el-button el-button--primary" style="color: white" :href="navigation.url" :underline="false">链接直达</el-link>
        <el-button type="success" v-if="this.token" @click="addToIndexVisible = true">添加到首页</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-alert
          title="特别声明"
          type="warning"
          :closable="false"
          :description="'本站在' + navigation.created_at + '收录外部站点【' + navigation.name + '】作为网址导航，因外部站点不由本站所有者进行管理，所以本站不保证外部站点所提供内容的完整性和准确性，并且外部站点的所有行为也均与本站无关，请您自行辨别，如外部站点出现违规违法情况，请联系我们进行删除。'"
          show-icon>
        </el-alert>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <h3>最新导航</h3>
      </el-col>
      <el-col v-for="navigation in newestNavigationList" :key="navigation.nid" :span="4">
        <el-link :href="'/nav/'+navigation.nid" :underline="false">
          <el-image class="navigation-logo-normal" :src="navigation.icon" :alt="navigation.name" />
          <div style="width: 100px; text-align: center; overflow: hidden">{{navigation.name}}</div>
        </el-link>
      </el-col>
    </el-row>
    <el-dialog title="请选择要添加到首页的位置" :visible.sync="addToIndexVisible" :close-on-click-modal="false">
      <el-row>
        <el-col :span="2" v-for="navigation in navigationList" :key="navigation.coordinate">
          <el-image
            draggable="false"
            class="navigation-logo-small"
            :src="navigation.icon ? navigation.icon : ''"
            :alt="navigation.name"
            :data-coordinate="navigation.coordinate"
            @click="addToIndex">
            <!-- 占位图-->
            <div slot="placeholder"
              style="padding-top: 100%; background-color: #f5f7fa"
              :data-coordinate="navigation.coordinate"
              @click="addToIndex">
              <span class="logo-placeholder">
                {{navigation.coordinate}}
              </span>
            </div>
            <!-- 错误图-->
            <div slot="error"
              style="padding-top: 100%; background-color: #f5f7fa;"
              :data-coordinate="navigation.coordinate"
              @click="addToIndex">
              <span class="logo-placeholder">
                {{navigation.coordinate}}
              </span>
            </div>
          </el-image>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addToIndexVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </el-main>

</template>

<script>
export default {
  name: 'Navigation',
  data () {
    return {
      token: localStorage.getItem('token'),
      nid: this.$route.params.nid,
      addToIndexVisible: false,
      navigation: {},
      newestNavigationList: [],
      navigationList: []
    }
  },
  created: function () {
    this.$http.defaults.baseURL = process.env.VUE_APP_BASE_API
    this.getNavigationInfo()
    this.getNewestNavigationList()
    this.getNavigationList()
  },
  methods: {
    getNavigationInfo () {
      this.$http.get('navigation/get?nid=' + this.nid, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then((response) => {
        if (response.data.code === 0) {
          this.navigation = response.data.data
          document.title = this.navigation.name + ' - 网湖 - 网址导航|网站导航|网址大全|网站大全'
        } else {
          this.$message({message: response.data.msg, type: 'error'})
        }
      })
    },
    getNewestNavigationList () {
      this.$http.get('navigation/list').then((response) => {
        if (response.data.code !== 0) {
          this.$message({message: '获取数据失败', type: 'error'})
        } else {
          this.newestNavigationList = response.data.data.navigations.filter((item) => { return item.icon }).slice(0, 6)
        }
      })
    },
    getNavigationList () {
      this.$http.get('navigation/list', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then((response) => {
        if (response.data.code !== 0) {
          this.$message({message: '获取数据失败', type: 'error'})
        } else {
          this.navigationList = response.data.data.navigations
        }
      })
    },
    addToIndex (event) {
      this.$http.post('navigation/replace', {
        coordinate: event.target.dataset.coordinate,
        nid: this.nid
      }, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then((response) => {
        this.addToIndexVisible = false
        if (response.data.code === 80003) {
          localStorage.clear()
          window.location.href = '/login'
        } else if (response.data.code !== 0) {
          this.$message({message: response.data.msg, type: 'error'})
        } else {
          localStorage.removeItem('navigationList')
          this.navigationList = response.data.data.navigations
          this.$message({message: '添加成功', type: 'success'})
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.el-main {
  margin-left: 13%;
  width: 74%;
  min-height: 85vh;
}

.el-row {
  margin-bottom: 10px;
}

/* 弹窗居中 */
/deep/ .el-dialog {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  text-align: center;
}

/deep/ .el-dialog .el-col {
  margin-bottom: 1vh;
}

/* Logo占位图和无Logo时的样式 */
.logo-placeholder {
  pointer-events: none; /* 这个是为了让文字不接受事件，要不然悬浮高亮会有问题 */
  white-space: nowrap;
  overflow: hidden;
  color: #f0c78a;
  /* 这里解决了文字居中问题，感谢文心一言 */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.navigation-logo-large {
  width: 200px;
  height: 200px;
  border: 1px solid #CCCCCC;
  border-radius: 50px;
}

.navigation-logo-normal {
  width: 100px;
  height: 100px;
  border: 1px solid #CCCCCC;
  border-radius: 25px;
}

.navigation-logo-small {
  width: 50px;
  height: 50px;
  border: 1px solid #CCCCCC;
  border-radius: 15px;
}

</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue